import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { schemaTemplatesMailHeader } from '../tables';

type Arguments = {
    position?: number;
};

export const schemaTemplateResolver_GetHeaders = schemaTemplatesMailHeader
    .pick({
        createdAt: true,
        data: true,
        id: true,
        type: true,
    })
    .nullable();

export type SchemaTemplateResolver_GetHeaders = z.infer<typeof schemaTemplateResolver_GetHeaders>;

export type TemplateResolver_GetHeaders = Resolver<Arguments, SchemaTemplateResolver_GetHeaders>;
